<template>
    <div>
        <div class="container-fluid">
            <div class="row margin-0" v-if="candidates.length">
                <div class="col-md-8" ref="infoBox" id="info-box">
                    <form action="">
                        <div class="filter-box">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="view-com-btn pt-0">
                                        <label class="ep-input-label default-label">Search Candidate By</label>
                                        <input type="text" class="form-control search-input" v-model="candName"
                                               placeholder="Name"/>
                                        <input type="text" class="form-control search-input" v-model="candRollNumber"
                                               placeholder="Roll Number"/>
                                        <button type="button" class="main-button-primary" @click="getCandidates()">
                                            Search
                                        </button>
                                        <button type="button" class="default" @click="OnFiltersClick">
                                            <i class="fas fa-filter"></i>
                                        </button>
                                    </div>
                                    <div v-show="filters" style="padding-top: 10px;">
                                        <span>Filters:</span>
                                        <button type="button" class="filter-btn" @click="OnCourseClick">
                                            Courses
                                        </button>
                                        <button type="button" class="filter-btn" @click="OnSemClick">
                                            Year/Semester
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="text-right-btn">
                                        <router-link class="filter-btn" to="/dashboard/manage-candidates">Manage
                                            Candidates
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row padd-top-10" v-show="isCourse">
                            <div class="course-filter">
                                <ul>
                                    <li v-for="c in courses">
                                        <input class="checkbox" v-bind:id="'lists[' + c.course_name+']'" type="checkbox"
                                               name="courses" :value="c.course_name" @change="getCandidates()"/>
                                        <label :for="'lists['+c.course_name+']'">
                                            <div>
                                                <span class="check">✓</span> {{ c.course_name }}
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row padd-top-10" v-show="isSem">
                            <div class="course-filter">
                                <ul>
                                    <li>
                                        <input class="checkbox" id="list[sem1]" type="checkbox" name="semesters"
                                               value="1" @change="getCandidates()"/>
                                        <label for="list[sem1]">
                                            <div>
                                                <span class="check">✓</span> Semester 1
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem2]" type="checkbox" name="semesters"
                                               value="2" @change="getCandidates()"/>
                                        <label for="lists[sem2]">
                                            <div>
                                                <span class="check">✓</span> Semester 2
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem3]" type="checkbox" name="semesters"
                                               value="3" @change="getCandidates()"/>
                                        <label for="lists[sem3]">
                                            <div>
                                                <span class="check">✓</span> Semester 3
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem4]" type="checkbox" name="semesters"
                                               value="4" @change="getCandidates()"/>
                                        <label for="lists[sem4]">
                                            <div>
                                                <span class="check">✓</span> Semester 4
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem5]" type="checkbox" name="semesters"
                                               value="5" @change="getCandidates()"/>
                                        <label for="lists[sem5]">
                                            <div>
                                                <span class="check">✓</span> Semester 5
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem6]" type="checkbox" name="semesters"
                                               value="6" @change="getCandidates()"/>
                                        <label for="lists[sem6]">
                                            <div>
                                                <span class="check">✓</span> Semester 6
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem7]" type="checkbox" name="semesters"
                                               value="7" @change="getCandidates()"/>
                                        <label for="lists[sem7]">
                                            <div>
                                                <span class="check">✓</span> Semester 7
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem8]" type="checkbox" name="semesters"
                                               value="8" @change="getCandidates()"/>
                                        <label for="lists[sem8]">
                                            <div>
                                                <span class="check">✓</span> Semester 8
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem9]" type="checkbox" name="semesters"
                                               value="9" @change="getCandidates()"/>
                                        <label for="lists[sem9]">
                                            <div>
                                                <span class="check">✓</span> Semester 9
                                            </div>
                                        </label>
                                    </li>
                                    <li>
                                        <input class="checkbox" id="lists[sem10]" type="checkbox" name="semesters"
                                               value="10" @change="getCandidates()"/>
                                        <label for="lists[sem10]">
                                            <div>
                                                <span class="check">✓</span> Semester 10
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--                        <div class="row padd-top-10" v-show="isJob">-->
                        <!--                            <div class="course-filter">-->
                        <!--                                <ul>-->
                        <!--                                    <li>-->
                        <!--                                        <input class="checkbox" id="lists[both]" type="checkbox" name="lists[both]"/>-->
                        <!--                                        <label for="lists[both]">-->
                        <!--                                            <div>-->
                        <!--                                                <span class="check">✓</span> Both-->
                        <!--                                            </div>-->
                        <!--                                        </label>-->
                        <!--                                    </li>-->
                        <!--                                    <li>-->
                        <!--                                        <input class="checkbox" id="lists[job]" type="checkbox" name="lists[job]"/>-->
                        <!--                                        <label for="lists[job]">-->
                        <!--                                            <div>-->
                        <!--                                                <span class="check">✓</span> Job-->
                        <!--                                            </div>-->
                        <!--                                        </label>-->
                        <!--                                    </li>-->
                        <!--                                    <li>-->
                        <!--                                        <input class="checkbox" id="lists[intern]" type="checkbox"-->
                        <!--                                               name="lists[intern]"/>-->
                        <!--                                        <label for="lists[intern]">-->
                        <!--                                            <div>-->
                        <!--                                                <span class="check">✓</span> Internship-->
                        <!--                                            </div>-->
                        <!--                                        </label>-->
                        <!--                                    </li>-->
                        <!--                                </ul>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                    </form>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="divider2"></div>
                        </div>
                    </div>
                    <div class="row margin-0">
                        <div class="col-md-12 col-sm-12">
                            <div class="row">
                                <div>
                                    <div class="col-md-4 col-sm-6" v-for="c in candidates">
                                        <div class="new-cand-box" @click="showData($event)" :data-semester="c.semester"
                                             :data-cgpa="c.cgpa" :data-city="c.city_name" :id="c.user_enc_id">
                                            <div class="row">
                                                <div class="col-md-3 col-sm-3 col-xs-3">
                                                    <div class="new-cand-icon">
                                                        <img :src="c.image" alt="">
                                                    </div>
                                                </div>
                                                <div class="col-md-9 col-sm-9 col-xs-9">
                                                    <div class="new-cand-details">
                                                        <div class="new-cand-name">{{ c.first_name }}
                                                            {{ c.last_name }}
                                                        </div>
                                                        <div class="new-cand-course">{{ c.name }}</div>
                                                        <div class="new-cand-course"><span
                                                            v-if="c.starting_year">{{ c.starting_year }}</span><span
                                                            v-if="c.ending_year">-{{ c.ending_year }}</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row position-bottom">
                                                <div class="col-md-6 col-sm-6 col-xs-6">
                                                    <div class="new-cand-sem" v-if="c.semester == 1">1st Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 2">2nd Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 3">3rd Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 4">4th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 5">5th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 6">6th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 7">7th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 8">8th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 9">9th Semester</div>
                                                    <div class="new-cand-sem" v-if="c.semester == 10">10th Semester
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-xs-6">
                                                    <div class="new-cand-apply">
                                                        <ul v-if="c.applied_companies.length">
                                                            <li v-for="(av, index) in c.applied_companies.slice(0,3)">
                                                                <div class="tooltip-main ssComapanies text-white">
                                                                    <img :src="av.logo">
                                                                    <span class="tooltiptext tooltip-bottom" v-html="av.name"></span>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="jobIocns stCards" v-if="c.loan_applied.length">
                                                <div class="tooltip-main text-white">
                                                    <i class="fas fa-hand-holding-usd"></i>
                                                    <span
                                                        class="tooltiptext tooltip-bottom">Applied Education Loan</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 height-100 cand-detail-main" id="cand-detail-main" v-if="user_detail != null">
                    <div v-bind:style="leftColStyles">
                        <div class="detail-box">
                            <div class="jobIocns stCards close-cand-details" @click="closeCandDetail()">
                                <div class="tooltip-main text-white">
                                    <i class="fas fa-times"></i>
                                </div>
                            </div>
                            <div class="db-two">
                                <div class="scroll-box">
                                    <div class="scroll-slim">
                                        <div class="col-md-12">
                                            <div class="new-detail-icon2 icon-center">
                                                <div class="new-detail-icon">
                                                    <img :src="user_detail.image" alt="">
                                                </div>
                                                <div class="student-social-icon">
                                                        <div class="showNumsDiv">
                                                            <span @click="hideConData($event)" class="closeNum"><i
                                                                class="fas fa-times"></i></span>
                                                            <span class="dataDis"></span>
                                                        </div>
                                                        <ul>
                                                            <li>
                                                                <i class="fab fa-whatsapp" @click="showConData($event)"
                                                                   v-bind:data-value="user_detail.phone"></i>
                                                            </li>
                                                            <li>
                                                                <i class="far fa-envelope" @click="showConData($event)"
                                                                   v-bind:data-value="user_detail.email"></i>
                                                            </li>
                                                        </ul>
                                            </div>
                                            </div>
                                            <div class="new-detail-name left-detail margin-top-20">
                                                {{ user_detail.first_name }}
                                                {{ user_detail.last_name }}
                                            </div>
                                            <div class="new-detail-course left-detail"> {{ user_detail.name }}</div>
                                            <div class="new-detail-course left-detail">
                                                <span v-if="user_detail.semesters == 1">1st Semester</span>
                                                <span v-if="user_detail.semesters == 2">2nd Semester</span>
                                                <span v-if="user_detail.semesters == 3">3rd Semester</span>
                                                <span v-if="user_detail.semesters == 4">4th Semester</span>
                                                <span v-if="user_detail.semesters == 5">5th Semester</span>
                                                <span v-if="user_detail.semesters == 6">6th Semester</span>
                                                <span v-if="user_detail.semesters == 7">7th Semester</span>
                                                <span v-if="user_detail.semesters == 8">8th Semester</span>
                                                <span v-if="user_detail.semesters == 9">9th Semester</span>
                                                <span v-if="user_detail.semesters == 10">10th Semester</span>
                                            </div>
                                            <div class="new-cand-course left-detail" v-if="user_detail.ending_year">
                                                {{ user_detail.starting_year }}-{{ user_detail.ending_year }}
                                            </div>
                                            <div class="new-cand-course left-detail" v-else="user_detail.ending_year">
                                                {{ user_detail.starting_year }}
                                            </div>
                                            <div class="new-detail-course left-detail">
                                                CGPA/Marks: <span
                                                v-if="user_detail.cgpa">{{ user_detail.cgpa }}</span><span
                                                v-else>N/A</span>
                                            </div>
                                            <div class="new-detail-course left-detail">
                                                Location: <span
                                                v-if="user_detail.city_name">{{ user_detail.city_name }}</span><span
                                                v-else>N/A</span>
                                            </div>
                                            <div class="row" v-if="user_detail && user_detail.applied_companies.length">
                                                <div class="col-md-12">
                                                    <div class="cd-heading margin-top-20">Companies Applied In</div>
                                                    <div class="applied-com-names">
                                                        <ul>
                                                            <li v-for="ac in user_detail.applied_companies">
                                                                <router-link :to="{path: '/profile?slug=' + ac.slug}">
                                                                    <img :src="ac.logo" :alt="ac.name">
                                                                    <span v-html="ac.name"></span>
                                                                </router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="user_detail && user_detail.applied_jobs.length">
                                                <div class="col-md-12">
                                                    <div class="cd-heading margin-top-20">Applied Jobs</div>
                                                    <div class="applied-com-names">
                                                        <ul>
                                                            <li v-for="ac in user_detail.applied_jobs">
                                                                <router-link :to="{path: '/detail?id=' + ac.slug}">
                                                                    <img :src="ac.logo" :alt="ac.name">
                                                                    <span v-html="ac.title"></span>
                                                                    <span style="color:#333;" v-if="ac.application_status == 'Rejected' || ac.application_status == 'Hired' || ac.application_status == 'Cancelled'">
                                                                        ({{ac.application_status}})
                                                                    </span>
                                                                    <span style="color:#333;" v-else-if="parseInt(ac.current_round) <= ac.appliedApplicationProcesses.length">
                                                                        ({{ac.appliedApplicationProcesses[parseInt(ac.current_round) -1].field_name}})
                                                                    </span>
                                                                </router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row"
                                                 v-if="user_detail && user_detail.applied_internships.length">
                                                <div class="col-md-12">
                                                    <div class="cd-heading margin-top-20">Applied Internships</div>
                                                    <div class="applied-com-names">
                                                        <ul>
                                                            <li v-for="ac in user_detail.applied_internships">
                                                                <router-link :to="{path: '/detail?id=' + ac.slug}">
                                                                    <img :src="ac.logo" :alt="ac.name">
                                                                    <span v-html="ac.title"></span>
                                                                    <span style="color:#333;" v-if="ac.application_status == 'Rejected' || ac.application_status == 'Hired' || ac.application_status == 'Cancelled'">
                                                                        ({{ac.application_status}})
                                                                    </span>
                                                                    <span style="color:#333;" v-else-if="parseInt(ac.current_round) <= ac.appliedApplicationProcesses.length">
                                                                        ({{ac.appliedApplicationProcesses[parseInt(ac.current_round) -1].field_name}})
                                                                    </span>
                                                                </router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="user_detail && user_detail.loan_applied.length">
                                                <div class="col-md-12">
                                                    <div class="cd-heading margin-top-20">Applied Loan Applications</div>
                                                    <div class="applied-com-names">
                                                        <ul>
                                                            <li v-for="(ac, index) in user_detail.loan_applied">
                                                                <ul>
                                                                    <li><h5 class="mb-0"><strong>Application {{index + 1}}</strong></h5></li>
                                                                    <li><strong>Amount:-</strong> <span>{{ac.amount}}</span></li>
                                                                    <li><strong>Status:- </strong>
                                                                        <span v-if="ac.status == 0">Pending</span>
                                                                        <span v-if="ac.status == 1">Approved</span>
                                                                        <span v-if="ac.status == 2">Rejected</span>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12 text-center">
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found" v-if="!hasData">No Candidates Found or Approved Yet</h2>
                </div>
            </div>
            <div id="loading-list">
                <div class="loading-list"></div>
                <div class="loading-list-ring"></div>
            </div>
        </div>
        <div id="cand-detail-open" class="cand-detail-open"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
    data: function () {
        return {
            leftColStyles: {},
            isCourse: false,
            isSem: false,
            isJob: false,
            filters: false,
            hasData: true,
            candName: '',
            candRollNumber: '',
            user_detail: '',
            candidates: '',
            courses: '',
        }
    },
    mounted() {
        this.matchHeight();
        let bdy = document.querySelector('body');
        bdy.onclick = function () {
            let showNumsDiv = document.querySelector('.showNumsDiv');
            if (showNumsDiv && showNumsDiv.classList.contains('showDivNum')) {
                showNumsDiv.classList.remove('showDivNum');
            }
        }

        var t = this;
        var url = this.$store.getters.getDomain;

        axios.post(`${url}api/v2/college-index/courses`, '', {headers: requestHeaders()}).then(function (response) {
            document.getElementById("h-page-load").classList.add("hides");
            t.courses = response['data']['response']['courses'];
        });
        t.getCandidates();
    },
    methods: {
        showConData(event) {
            let clickedElem = event.target;
            let elemVal = clickedElem.getAttribute('data-value');
            let showNumsDiv = document.querySelector('.showNumsDiv');
            let dataDis = showNumsDiv.querySelector('.dataDis')
            dataDis.innerHTML = elemVal;
            setTimeout(function () {
                showNumsDiv.classList.add('showDivNum');
            }, 200)
        },
        hideConData(event) {
            let clickedElem = event.target;
            let parElem = clickedElem.parentElement;
            let rootElem = parElem.parentElement;
            rootElem.classList.remove('showDivNum');
        },
        matchHeight() {
            if (this.$refs.infoBox) {
                var heightString = this.$refs.infoBox.clientHeight + 'px';
                Vue.set(this.leftColStyles, 'height', heightString);
            }
        },
        OnCourseClick: function () {
            this.isCourse = !this.isCourse;
            this.isSem = false;
            this.isJob = false
        },
        OnFiltersClick: function () {
            this.filters = !this.filters;
        },
        OnSemClick: function () {
            this.isSem = !this.isSem;
            this.isCourse = false;
            this.isJob = false
        },
        OnJobClick: function (event) {
            this.isJob = !this.isJob;
            this.isCourse = false;
            this.isSem = false

        },
        showData: function (event,isOpen = true) {
            var t = this;
            var element;
            if(isOpen) {
                element = event.currentTarget;
            } else {
                element = event;
            }
            var rm_elem = document.getElementsByClassName('new-cand-box');
            for (var r = 0; r < rm_elem.length; r++) {
                if (rm_elem[r].classList.contains('active')) {
                    rm_elem[r].classList.remove('active');
                }
            }
            if(isOpen){
                document.getElementById('cand-detail-open').classList.add('open');
                document.getElementById('cand-detail-main').classList.add('open');
            }
            element.classList.add("active");
            t.user_detail = t.$store.getters.getCandidatesById(element.getAttribute('id'))[0];
        },
        closeCandDetail(){
            document.getElementById('cand-detail-open').classList.remove('open');
            document.getElementById('cand-detail-main').classList.remove('open');
        },
        getCandidates() {
            var fadeTarget = document.getElementById("loading-list");
            if (fadeTarget) {
                fadeTarget.style.display = "block";
            }
            var t = this;
            var url = this.$store.getters.getDomain;

            var obj = {};
            obj['user_id'] = t.$route.query.id;
            var courses_arr = [];
            var courses = document.getElementsByName('courses');
            for (var k = 0; k < courses.length; k++) {
                if (courses[k].checked) {
                    courses_arr.push(courses[k].value);
                }
            }
            obj['courses'] = courses_arr;
            obj['name'] = t.candName;
            obj['roll_no'] = t.candRollNumber;
            var semesters_arr = [];
            var semesters = document.getElementsByName('semesters');
            for (var l = 0; l < semesters.length; l++) {
                if (semesters[l].checked) {
                    semesters_arr.push(semesters[l].value);
                }
            }
            obj['semesters'] = semesters_arr;

            axios.post(`${url}api/v2/college-index/view-all-candidates`, obj, {headers: requestHeaders()}).then(function (response) {
                document.getElementById("h-page-load").classList.add("hides");
                if (response['data']['response']['all_candidates'].length) {
                    t.candidates = response['data']['response']['all_candidates'];
                    t.$store.dispatch("setCandidates", t.candidates);
                    setTimeout(function () {
                        if (t.$route.query.id && document.getElementById(t.$route.query.id)) {
                            t.showData(document.getElementById(t.$route.query.id),false);
                        } else {
                            if (document.getElementsByClassName('new-cand-box')[0]) {
                                t.showData(document.getElementsByClassName('new-cand-box')[0],false);
                            }
                        }
                        t.matchHeight();
                        $('.scroll-slim').perfectScrollbar();
                    }, 700)
                } else {
                    t.candidates = [];
                    t.hasData = false;
                }
                if (fadeTarget) {
                    fadeTarget.style.display = "none";
                }
            });
        }
    },
}
</script>

<style scoped>
.course-filter ul li {
    display: inline-block;
    padding: 0 0 0 15px;
}

.student-social-icon {
    text-align: center;
    margin-top: 50px;
    position: relative;
}

.closeNum {
    cursor: pointer;
}

.closeNum:hover {
    color: #00a0e3;
    transition: .3s ease;
}

.student-social-icon ul li {
    display: inline-block;
    padding: 5px;
    position: relative;
}

.showNumsDiv {
    position: absolute;
    top: -125%;
    left: 35%;
    transform: translateX(-50%);
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    width: 140%;
    padding: 10px;
    border-radius: 8px;
    display: none;
}

.showNumsDiv span i {
    font-size: 14px !important;
    padding: 0 5px 0 0;
    margin-right: 5px;
    border-right: 1px solid #eee;
}

.showNumsDiv .dataDis{
    word-break: break-all;
}

.showDivNum {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.student-social-icon ul li i {
    font-size: 25px;
    cursor: pointer;
}

.student-social-icon ul li i.fa-whatsapp {
    color: #4FCE5D;
}

.student-social-icon ul li i.fa-envelope {
    color: #00a0e3;
}

label {
    display: block;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    height: 50px;
    /*width: 100%;*/
    padding: 0 30px;
    border-radius: 5px;
    font-family: Roboto;
    color: #333;
    text-align: center;
    display: table;
    position: relative;
}

label div {
    vertical-align: middle;
    display: table-cell;
}

label span {
    position: absolute;
    top: 3px;
    right: 5px;
}

input[type=checkbox] {
    display: none;
}

input:checked + label {
    transition: .2s ease;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    color: #00a0e3;
}

/* new stuff */
.check {
    padding-top: 0px !important;
    visibility: hidden;
}

input:checked + label .check {
    visibility: visible;
}

input.checkbox:checked + label:before {
    content: "";
}

.text-right-btn {
    text-align: right;
    padding-right: 20px;
}

.detail-box {
    margin-top: 15px;
}

.loading-list {
    top: 0;
}

.search-input {
    display: inline-block;
    width: auto;
    margin-right: 15px;
}

.new-cand-box.active {
    border: 1px solid #00a0e3;
}

.new-detail-icon2 {
    float: right;
}

.left-detail {
    max-width: calc(100% - 160px);
}
.loading-list,.loading-list-ring{
    z-index: 99;
}
.close-cand-details{
    display: none;
}
@media screen and (max-width: 991px) {
    .margin-0{
        margin: 0px;
    }
    .cand-detail-main {
        display: none;
    }
    .detail-box{
        position: fixed;
        z-index: 999999;
        right: 5vw;
        top: 5vh;
        width: 90vw;
        height: 80vh;
        overflow: scroll;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);
        border-radius: 10px;
    }
    .scroll-box{
        height: auto;
    }
    .scroll-slim{
        position: relative;
        height: calc(100vh - 28vh);
    }
    .cand-detail-open{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 99999;
        background-color: #000;
        opacity: 0.6;
        display: none;
    }
    .cand-detail-open.open, .cand-detail-main.open,.close-cand-details{
        display: block;
    }
    .jobIocns.stCards.close-cand-details{
        background-color: red;
        width: 50px;
        height: 38px;
        line-height: 38px;
        font-size: 20px;
    }
}
</style>